import Tab from './Tab';
import { setJSONToCdekSelect } from '../../../helpers';
import { textareaCounter } from '../../../service/validate';
import { OrderInterface } from './order.interface';

export default class OrderFormBySteps extends OrderInterface {
  /**
   * @param {HTMLElement} order - ClassName order element
   * @param {boolean} debug - Disable validation
   * @param {[plugin]} plugins
   */
  constructor(order, plugins, debug) {
    super();
    const { hash } = window.location;
    this.order = order;
    this.debug = debug;
    this.TAB_STATES.step = Number(hash.charAt(hash.length - 1)) ?? 1;
    this.TAB_STATES.opened = Number(hash.charAt(hash.length - 1)) ?? 1;

    const tabs = this.order?.querySelectorAll('[data-step]');
    if (this.order !== null && this.order !== undefined) {
      Array.prototype.filter.call(tabs, (el) => {
        this.TABS.push(new Tab(el));
      });

      const forms = this.order.querySelectorAll('form');
      this.TAB_STATES.lastStep = [...forms].length;
      this.setDataFromStorage();
      this.listenClickStep();
      this.collapseListen();
      setJSONToCdekSelect();
      textareaCounter();
      this.onChangeDeliveryType();

      if (!this.debug) {
        this.disableNonPassedStep().onStep(forms);
      }

      [...plugins].forEach((plugin) => {
        plugin
          .setParent(this)
          .init();
      });

      this.setDataFromStorage();
      this.onFormChange();
    } else {
      // eslint-disable-next-line no-console
      console.warn('Order is null or not exist');
    }
  }

  /**
   * @returns {Promise<AxiosResponse<any>>}
   */
  async sendForm() {
    return window.axios
      .post('/v1/form/order', this.DataForm)
      .then(response => response)
      .catch(error => error);
  }
}
